let sample: {server:number;local:number}|null=null;

/** Use a monotonic client clock; a visitor's device date does not decide the programme. */
export function sampleServerClock(server:number, sent:number, received:number) {
  if(Number.isFinite(server)&&received>=sent) sample={server:server+(received-sent)/2,local:received};
}

export function serverNow() {
  return sample ? sample.server+performance.now()-sample.local : null;
}

export function playbackPosition(start:string,duration:number,end?:string):number|null {
  const now=serverNow(),epoch=Date.parse(start);
  if(now===null||!Number.isFinite(epoch)||!Number.isFinite(duration)||duration<=0)return null;
  const elapsed=Math.max(0,(now-epoch)/1000);
  return end?Math.min(elapsed,Math.max(0,duration-0.1)):elapsed%duration;
}
